import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { themeReducer } from "./themeReducer";
import { communicationReducer } from "./communicationReducer";
import { notificationReducer } from "./notificationReducer";
import { jobsReducer } from "./jobsReducer";

export const Reducers = combineReducers({
  user: userReducer,
  communicationState: communicationReducer,
  notificationState: notificationReducer,
  theme: themeReducer,
  jobsState: jobsReducer
});
